import {FileDownload} from "../api/ApiTypes.ts";
import {BaseFormComponent} from "../components/dynamicforms/DynamicFormTypes.ts";


export const base64ToArrayBuffer = (base64Content: string) => {
    let binaryString = window.atob(base64Content);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

export const handleView = async (download: FileDownload) => {
    try {
        const url = convertToBlobAndCreateTempUrl(download);
        // Open in a new tab
        window.open(url, '_blank');
        // Clean up the URL object after a delay to ensure it loads
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 5000);
    } catch (error) {
        console.error('Failed to view file:', error);
        throw error;
    }
};

export const handleDownload = async (download: FileDownload) => {
    try {
        const url = convertToBlobAndCreateTempUrl(download);
        // Create a temporary anchor element and trigger download
        const a = document.createElement('a');
        a.href = url;
        a.download = download.fileName;
        document.body.appendChild(a);
        a.click();
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error('Failed to download file:', error);
        throw error;
    }
};

export const convertToBlobAndCreateTempUrl = (download: FileDownload): string => {
    const blob = new Blob([base64ToArrayBuffer(download.data)], { type: download.contentType || 'application/octet-stream' });
    // Create a temporary URL for the blob
    return window.URL.createObjectURL(blob);
};

export const generateComponentId = (component: BaseFormComponent): string => {
    return `${component.fieldKey}-${component.type}-component-id`;
}

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

